import { render, staticRenderFns } from "./LaudoCarbonoModal.vue?vue&type=template&id=1ebff1eb&scoped=true&lang=pug"
import script from "./LaudoCarbonoModal.vue?vue&type=script&lang=js"
export * from "./LaudoCarbonoModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoCarbonoModal.vue?vue&type=style&index=0&id=1ebff1eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebff1eb",
  null
  
)

export default component.exports